import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getStockrooms, createStockroom } from '../../services/stockroom'

export const getStockroomsAction = createAsyncThunk('stockrooms/get', async (payload, { rejectWithValue }) => {
  try {
    const data = await getStockrooms(payload.pagination)
    return data.data
  } catch (e) {
    return rejectWithValue(e.response.data)
  }
})

export const createStockroomAction = createAsyncThunk(
  'stockrooms/create',
  async ({ name, isCentral, project }, { rejectWithValue }) => {
    try {
      const response = await createStockroom({
        data: { data: { name, project, is_central: isCentral } },
      })
      return response.data
    } catch (e) {
      return rejectWithValue(e.response.data)
    }
  }
)

export const stockroomSlice = createSlice({
  name: 'stockroom',
  initialState: {
    stockrooms: [],
    pagination: {},
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: '',
  },
  extraReducers: {
    [getStockroomsAction.pending]: (state) => {
      state.isFetching = true
    },
    [getStockroomsAction.rejected]: (state, { payload }) => {
      state.isFetching = false
      state.isError = true
      state.errorMessage = payload.message
    },
    [getStockroomsAction.fulfilled]: (state, data) => {
      state.stockrooms = data.payload.data
      state.pagination = data.payload.meta.pagination
      state.isFetching = false
      state.isSuccess = true
      return state
    },
  },
})

export const stockroomSelector = (state) => state.stockroom
